import { render } from "./EmailReviewModal.vue?vue&type=template&id=ab97f916&scoped=true&ts=true"
import script from "./EmailReviewModal.vue?vue&type=script&lang=ts"
export * from "./EmailReviewModal.vue?vue&type=script&lang=ts"

import "./EmailReviewModal.vue?vue&type=style&index=0&id=ab97f916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab97f916"]])

export default __exports__